<div class="h-16 hidden block-sm"></div>
<div class="affix affix-top-40">
  <div class="card-decoration-container">
    <div class="tag tag-violet typography typography-body">
      Акция&nbsp;
      <span class="typography-bold">%</span>
    </div>
  </div>
  <div class="card card-border-1 full-width">
    <div class="card-body">
      <div class="typography typography-bold typography-body typography-paragraph" style="margin-top: 16px">
        Акция действует:
      </div>
      <div class="grid grid-gutter-8">
        <div class="grid-item">
          <div class="icon icon-20 icon-calendar-dates"></div>
        </div>
        <div class="grid-item">
          <div class="typography typography-body" *ngIf="startDate">
            с {{formattedDate(startDate) | date: "dd MMMM yyyy года"}}
          </div>
          <div class="typography typography-body" *ngIf="endDate">
            по {{formattedDate(endDate) | date: "dd MMMM yyyy года"}}
          </div>
          <div class="typography typography-body" *ngIf="!startDate && !endDate">
            Бессрочно
          </div>
        </div>
      </div>
      <div class="grid grid-gutter-8 green-basic go-to-map"
        *ngIf="showGoToMap" (click)="goToMap()">
        <div class="grid-item">
          <div class="icon icon-20 icon-pin-add"></div>
        </div>
        <div class="grid-item">
          <a>
            {{mapLinkText$ | async}}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
